module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-W-drill-shadow.8727c4fa.png";